import { useLocation, useNavigate } from 'react-router';
import { useBuildRun } from '../state/buildRun';
import { funnelStep } from '../analytics/funnel';

/** The steps before the build: where somebody who stepped back from it lands. */
const BEFORE_THE_BUILD = ['/new/idea', '/new/what', '/new/questions', '/new/plan'];

/**
 * "Your app is still building · See it" (owner, 2026-10-25). A signed-out build runs behind the offer,
 * so the build overlay says nothing on other screens, and somebody who stepped back from the building
 * screen did not know their app was still being made (three of four, Oct 24–25). While a build runs or
 * waits for them, the steps before it carry this bar back to it.
 */
export default function StillBuildingBar() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const status = useBuildRun((s) => s.status);
  const heldApp = useBuildRun((s) => s.heldApp);
  if (!BEFORE_THE_BUILD.includes(pathname)) return null;
  if (status !== 'running' && !heldApp) return null;
  const name = heldApp?.name;
  return (
    <button
      type="button"
      className="still-building-bar"
      onClick={() => {
        funnelStep('still_building_pressed', {}, { now: true });
        navigate('/new/building');
      }}
    >
      <span className="still-building-dot" aria-hidden="true" />
      <span>{status === 'running' ? 'Your app is still building' : `${name || 'Your app'} is ready`}</span>
      <span className="still-building-see">See it</span>
    </button>
  );
}
